import axios from "axios";
import { userLogout } from "../utils/common";

// let apiBasePath = "https://uat-apps.mufinpay.com";
let apiBasePath = "";
// let apiBasePath = process.env.NODE_ENV === 'development' ? '' : 'https://uat-apps.mufinpay.com';
class ApiRequest {
  constructor(dispatch, successFn, errorFn) {
    this.successFn = typeof successFn === "function" ? successFn : () => {};
    this.errorFn = typeof errorFn === "function" ? errorFn : () => {};
    this.dispatch = typeof dispatch === "function" ? dispatch : () => {};
  }

  instance() {
    const token = sessionStorage.getItem("authToken");
    const headers = {
      "Content-Type": "application/json",
      apikey: "e9480c57-0bed-45f7-b7d2-79a06w20p",
      ...(token ? { Authorization: `${token}` } : {}),
    };

    const instance = axios.create({
      baseURL: "",
      headers,
    });

    return instance;
  }

  /**
   * GET Requests
   * @param {string} url
   * @param {object} params
   */
  async get(url, params = {}) {
    try {
      const res = await this.instance().get(apiBasePath + url, params);
      // const data = res.data ? res.data : null;
      // const headers = res.headers ? res.headers : null;
      this.successFn(res);
      return res;
    } catch (error) {
      // const data = error.hasOwnProperty('data') ? data : null;
      // const headers = error.hasOwnProperty('headers') ? headers : null;

      if (error && error.response && error.response.status === 401) {
        userLogout();
        window.location.href = "/admin";
      }

      this.errorFn(error);
    }
  }

  /**
   * POST Requests
   * @param {string} url
   * @param {object} params
   */
  async post(url, params = {}) {
    try {
      const res = await this.instance().post(apiBasePath + url, params);
      this.successFn(res);
      return res;
    } catch (error) {
      // const {
      //   response: { data = {}, status },
      // } = error;

      if (error && error.response && error.response.status == "401") {
        // need to check the status code for making user logout
        userLogout();
      }

      //   this.errorFn(data, status);
    }
  }

  /**
   * PUT Requests
   * @param {string} url
   * @param {object} params
   */
  async put(url, params = {}) {
    try {
      const res = await this.instance().put(apiBasePath + url, params);
      const { data = {}, status } = res;
      this.successFn(data, status);
      return res;
    } catch (error) {
      // const {
      //   response: { data = {}, status },
      // } = error;

      if (error && error.response && error.response.status == "401") {
        // need to check the status code for making user logout
        userLogout();
      }

      //   this.errorFn(data, status);
    }
  }

  /**
   * DELETE Requests
   * @param {string} url
   * @param {object} params
   */
  async delete(url, params = {}) {
    try {
      const res = await this.instance().delete(apiBasePath + url, params);
      const { data = {}, status } = res;
      this.successFn(data, status);
      return res;
    } catch (error) {
      //handle error
    }
  }
}
export default ApiRequest;
